import { useEffect, useState } from 'react';

export default function useTilePreview(file, fallbackUrl) {
  const [objectUrl, setObjectUrl] = useState(null);

  useEffect(() => {
    if (!file) {
      setObjectUrl(null);
      return undefined;
    }
    const url = window.URL.createObjectURL(file);
    setObjectUrl(url);
    return () => window.URL.revokeObjectURL(url);
  }, [file]);

  return objectUrl ?? fallbackUrl ?? null;
}
